import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  Label,
  CardSubtitle,
  Container,
  Spinner
} from "reactstrap";

import {
  AvForm,
  AvField,
} from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

import showNotification from "../../../../../helpers/show_notification";

import { postSubmitForm } from "../../../../../helpers/forms_helper";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import moment from "moment";
import { convertToLowestUnit, formatUnitsForReport, GetUpdatedDelivered,  } from "../../../../../helpers/units";
import { checkOutOfStock } from "../../../../../helpers/po_helper";
import EnterQuantityModal from "../../../../../components/EnterQuantityModal";
const animatedComponents = makeAnimated();

const ItemTransferInventory = (props) => {
  const refForForm = useRef(null);
  useEffect(() => {
    loadAllBranches();
  }, []);

  const refSelectBranch = useRef(null);
  const [allBranches, setAllBranches] = useState([]);
  const [allToBranches, setAllToBranches] = useState();
  const [selectedToBranch, setSelectedToBranch] = useState();
  const [allFromBranches, setAllFromBranches] = useState();
  const [selectedFromBranch, setSelectedFromBranch] = useState();
  const loadAllBranches = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const branch = response.data.filter(
        (store) => store.type === "Branch" || store.type === "CENTRAL KITCHEN STORE"
      );
      setAllBranches(branch);
      setAllToBranches(branch);
      setAllFromBranches(branch);
    } else {
      showNotification(response.message, "Error");
    }
  };

  useEffect(() => {
    if (selectedFromBranch) {
      refSelectBranchItem.current.select.clearValue();
      setSelectedBranchItem();
      loadAllBranchItems();
    }
  }, [selectedFromBranch]);

  const refSelectBatch = useRef(null);
  const refSelectBranchItem = useRef(null);
  const [allBranchItems, setAllBranchItems] = useState([]);
  const [selectedBranchItem, setSelectedBranchItem] = useState();
  const loadAllBranchItems = async () => {
    let url =
      process.env.REACT_APP_BASEURL + "branchitems/get_by_branch_for_transfer";
    let response = await postSubmitForm(url, {
      branch_id: selectedFromBranch._id,
    });
    if (response.status === 1) {
      let filtered = response.data?.filter((d)=>d.is_active) || [];
      setAllBranchItems(filtered);
    } else {
      showNotification(response.message, "Error");
    }
  };
  useEffect(() => {
    if (selectedBranchItem) {
      // refSelectBatch.current.select.clearValue();
      setSelectedBatch();
      loadAllBranchItemBatches();
    }
  }, [selectedBranchItem]);
  const [allBatches, setAllBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState();
  const loadAllBranchItemBatches = async () => {
    let url =
      process.env.REACT_APP_BASEURL +
      // "storeiteminventories/get_by_item_id";
      "branchiteminventories/get_by_item_branch";
    let response = await postSubmitForm(url, {
      branch_id: selectedFromBranch._id,
      item_id: selectedBranchItem.item_id,
    });
    if (response.status === 1) {
      const result = response.data
      const batchOptions = result.map(batch => ({
        ...batch,
        label: `${batch.batch} - Expiry: ${new Date(batch.expiry_date).toLocaleDateString()}`,
        value: batch._id
      }));
      setAllBatches(batchOptions);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [remarks, setRemarks] = useState();
  const [itemsForTransfer, setItemsForTransfer] = useState([]);
  const handleAddItemForTransfer = async (quantity) => {
        const {unit_levels,} = selectedBatch?.item_details;

  let available = convertToLowestUnit(unit_levels, selectedBatch?.quantity);
      let totalEntered = convertToLowestUnit(unit_levels, quantity);
      let convertedQuantity = GetUpdatedDelivered(quantity,unit_levels,)
      if(totalEntered>available){
          showNotification(`can not add more than available in batch`,"Warning");
          return;
      }
    var new_array_items = JSON.parse(JSON.stringify(itemsForTransfer));
    const existing_item = new_array_items.filter(function (item) {
      return item.batch === selectedBatch.batch;
    });

    if (existing_item.length > 0) {
      showNotification(
        props.t("This item batch is already added."),
        props.t("Error")
      );
    } else if (selectedBatch) {
      let item_to_add = {};
      item_to_add.item_id = selectedBranchItem.item_id;
      item_to_add.name = selectedBranchItem.name;
      item_to_add.category = selectedBranchItem.category;
      item_to_add.sub_category = selectedBranchItem.sub_category;
      item_to_add.brand = selectedBranchItem.brand;
      item_to_add.quantity = convertedQuantity.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
      item_to_add.unit_levels = selectedBranchItem.unit_levels;
      item_to_add.batch = selectedBatch.batch;
      item_to_add.expiry_date = selectedBatch.expiry_date;
      item_to_add.cost_price = selectedBatch.cost_price;
      item_to_add.selling_price = selectedBatch.selling_price;
      setItemsForTransfer([...itemsForTransfer, item_to_add]);
      setSelectUnitModal(false);
      setSelectedBatch();
      setSelectedRowsUnit([]);
      setSelectedBranchItem();
      refSelectBranchItem.current.select.clearValue();
    } else {
      showNotification(props.t("Select a item batch first."), props.t("Error"));
    }
  };

  const [isDisabled, setIsDisabled] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
      setIsDisabled(true)
      const object = {
        item_details: itemsForTransfer,
        remarks: v.remarks,
        branch_from: {
          branch_id: selectedFromBranch._id,
          name: selectedFromBranch.name,
          email: selectedFromBranch.email,
          mobile: selectedFromBranch.mobile,
        },
        branch_to: {
          branch_id: selectedToBranch._id,
          name: selectedToBranch.name,
          email: selectedToBranch.email,
          mobile: selectedToBranch.mobile,
        },
      };
      let url = process.env.REACT_APP_BASEURL + "itemtransferorders/insert";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        setIsDisabled(false)
        setRemarks();
        setItemsForTransfer([]);
        setSelectedBranchItem();
        refSelectBranchItem.current.select.clearValue();
        refForForm.current.reset();
        showNotification(response.message, "Success");
      } else {
        setIsDisabled(false)
        showNotification(response.message, "Error");
      }
    } catch (error) {
      setIsDisabled(false)
      showNotification(error.message, "Error");
    }
  };
 const handleDeleteRow = (batch) => {
    setItemsForTransfer((prevCartItems) => {
      const updatedCartItems = prevCartItems.filter((item) => item.batch !== batch);
      return updatedCartItems;
    });
  };
  const columns = [
    {
      dataField: "category",
      text: props.t("Category"),
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
    },
    {
      dataField: "name",
      text: props.t("Name"),
      sort: true,
    },
    {
      dataField: "batch",
      text: props.t("Batch"),
    },
    {
      dataField: "expiry_date",
      text: props.t("Expiry Date"),
      formatter: (cell, row) => {
               return row.expiry_date ? moment(row.expiry_date).format("DD/MM/YYYY") : '';

      },
    },
    {
      text: props.t("Transfer Quantity"),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return (
          <>
                {formatUnitsForReport(row.quantity)}
          </>
        )
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    {
      dataField: "",
      editable: false,
      text: "Remove",
      formatter: (cell, row) => {
        return (
          <span className="d-flex justify-content-center text-danger">
            <i
              className="bx bxs-trash font-size-20"
              title="Click to Remove"
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleDeleteRow(row.batch)
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      sort: false,
      footer: false,
    },
  ];

  function handleSelectBatch(e) {
    setSelectedBatch(e)
    setSelectUnitModal(!selectUnitModal)
  }

  const [selectUnitModal, setSelectUnitModal] = useState(false);
  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);
  function handleCloseModal() {
    setSelectUnitModal(false);
    setSelectedBatch()
    setSelectedRowsUnit([])
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Items")}
            title={props.t("Central Store")}
            breadcrumbItem1={props.t("Branch Inventory")}
            breadcrumbItem2={props.t("Transfer")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm
                    
                    ref={refForForm}
                  >
                    <CardTitle>{props.t("Inter-Branch Transfer")}</CardTitle>
                    <CardSubtitle className="mb-3">
                      {props.t(
                        "Enter the following details to initiate inter-branch transfer of finished items"
                      )}
                    </CardSubtitle>
                    <Row>
                      <Col lg={4}>
                        <Label>{props.t("To Branch")}</Label>
                        <Select
                          ref={refSelectBranch}
                          value={selectedToBranch}
                          onChange={(selected) => {
                            let arr = allBranches.filter(
                              (item) => item._id !== selected._id
                            );

                            setAllFromBranches(arr);
                            setSelectedToBranch(selected);
                          }}
                          options={allToBranches}
                          classNamePrefix="select2-selection"
                          components={animatedComponents}
                          required
                        />
                      </Col>
                      <Col lg={4}>
                        <Label>{props.t("From Branch")}</Label>
                        <Select
                          ref={refSelectBranch}
                          value={selectedFromBranch}
                          onChange={(selected) => {
                            let arr = allBranches.filter(
                              (item) => item._id !== selected._id
                            );
                            setAllBranchItems([]);
                            setItemsForTransfer([]);
                            setAllToBranches(arr);
                            setSelectedFromBranch(selected);
                          }}
                          options={allFromBranches}
                          classNamePrefix="select2-selection"
                          components={animatedComponents}
                          required
                        />
                      </Col>
                      {selectedFromBranch && (
                        <Col lg={4}>
                          <Label>{props.t("Item")}</Label>
                          <Select
                            ref={refSelectBranchItem}
                            value={selectedBranchItem}
                            onChange={(selected) => {
                              setSelectedBranchItem(selected);
                            }}
                            options={allBranchItems}
                            classNamePrefix="select2-selection"
                            components={animatedComponents}
                            required
                          />
                        </Col>
                      )}
                      {selectedBranchItem && (
                        <>
                          <Col lg={2}>
                            <br />
                            <Label>Available Quantity</Label>
                            <br />
                            <Label>
                              {formatUnitsForReport(selectedBranchItem?.available,selectedBranchItem?.unit_levels)}
                            </Label>
                          </Col>
                          <Col lg={2}>
                            <br />
                            <Label>Threshold Quantity</Label>
                            <br />
                            <Label>
                              {selectedBranchItem?.threshold +
                                " " +
                                selectedBranchItem?.unit_for_threshold}
                            </Label>
                          </Col>
                        </>
                      )}

                      {selectedBranchItem && checkOutOfStock(selectedBranchItem?.available) ? (
                        <Col lg={6}>
                          <p class="text-muted mb-2">&nbsp;</p>
                          <div class="alert alert-danger fade show text-center" role="alert">
                            {props.t("This item is out of stock.")}
                          </div>
                        </Col>
                      )
                        : (
                          selectedBranchItem && (
                           
                              <Col lg={4}>
                                <br />
                                <Label>{props.t("Batch")}</Label>
                                <Select
                                  ref={refSelectBatch}
                                  value={selectedBatch && selectedBatch}
                                  key={selectedBatch}
                                  onChange={(e) => { handleSelectBatch(e) }}
                                  options={allBatches && allBatches}
                                  classNamePrefix="select2-selection"
                                  required
                                />
                              </Col>
                            
                          )

                        )
                      }
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                  <hr />
                  {itemsForTransfer && itemsForTransfer.length > 0 && (
                    <>
                      <BootstrapTable
                        bootstrap4
                        keyField="_id"
                        data={itemsForTransfer && itemsForTransfer}
                        columns={columns}
                        noDataIndication="No data to display."
                        striped
                        hover
                        condensed
                      />
                      <AvForm onValidSubmit={handleValidSubmit}>
                        <Row>
                          <Col lg={6}>
                            <AvField
                              name="remarks"
                              value={remarks}
                              onChange={(e) => {
                                setRemarks(e.target.value);
                              }}
                              label={props.t("Remarks")}
                              placeholder={props.t("Enter Remarks")}
                              type="textarea"
                            />
                          </Col>
                          <Col lg={12}>
                            <hr />
                            <FormGroup className="mb-0 text-left">
                              <div>
                                <Button
                                  type="submit"
                                  disabled={isDisabled}
                                  style={{ width: '100px' }} 
                                  color="primary"
                                  className="mr-1"
                                >
                                  {isDisabled ? <Spinner size="sm" /> : props.t("Submit")} 
                                </Button>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </AvForm>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Add Quantity modal  */}
          <EnterQuantityModal
            isOpen={selectUnitModal}
            toggle={handleCloseModal}
            onSubmit={handleAddItemForTransfer}
            item={selectedBranchItem}
            checkLimitFor={"batch"}
            selectedBatch={selectedBatch}
          />
         
        </Container>
      </div>
    </React.Fragment>
  );
};
export default withRouter(
  connect(null, {})(withNamespaces()(ItemTransferInventory))
);
